import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/word.png'
import _imports_1 from '../../assets/img/yimo-img/des-3-1.png'
import _imports_2 from '../../assets/img/yimo-img/interface.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-25ec760d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "next" }, null, -1))
const _hoisted_2 = { class: "page-bg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "accompanyWord",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linkyimo1",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "interface",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["box3 animate__faster", { animate__animated: _ctx.nowPage === 4, animate__fadeInRight: _ctx.nowPage === 4 }])
      }, [
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass(["pageTowWord", {
          animate__animated: _ctx.nowPage === 4,
          animate__fadeInRight: _ctx.nowPage === 4
        }])
        }, [
          _createTextVNode(" 语音聊天室连麦嗨聊，百万大神专业指导"),
          _hoisted_4,
          _createTextVNode("更有1000+聊天室在线点播，游戏娱乐两不误！ ")
        ], 2),
        _hoisted_5
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box2 animate__faster", {
        animate__animated: _ctx.nowPage === 4,
        animate__fadeInLeft: _ctx.nowPage === 4
      }])
      }, _hoisted_7, 2)
    ])
  ], 64))
}